import type { Chain } from "./queries"

const MAINNET_LOGO_URL =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMTUiIGhlaWdodD0iMjE1IiB2aWV3Qm94PSIwIDAgMjE1IDIxNSIgZmlsbD0ibm9uZSI+PHBhdGggZD0ibTE2MSAxMDYuNCAyOS4zLTE0LjYgMTAuMS0zMS0yMC4yLTE0LjdINDUuN0wxNC42IDY5LjJoMTU4LjFsLTguNCAyNmgtNjMuNGwtNi4xIDE5aDYzLjRsLTE3LjggNTQuNyAyOS43LTE0LjcgMTAuNi0zMi44LTE5LjktMTQuNnoiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJtNTkuMyAxNDUuNCAxOC4zLTU3LTIwLjMtMTUuMi0zMC41IDk1LjdoMTEzLjZsNy42LTIzLjV6IiBmaWxsPSIjZmZmIi8+PC9zdmc+"

export const mainnet: Chain = {
  identifier: "ethereum",
  name: "Ethereum",
  networkId: 1,
  rpcUrl: "https://eth.llamarpc.com",
  rpcUrlPublic: "https://eth.llamarpc.com",
  contractDeploymentEnabled: true,
  arch: "EVM",
  swapsSupported: true,
  crossChainBuysSupported: true,
  onlyCurrencySupport: false,
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    imageUrl: "https://raw.seadn.io/files/ETH.svg",
    chain: "ethereum",
    contractAddress: "0x0000000000000000000000000000000000000000",
    chainIdentifier: "ethereum",
  },
  wrappedNativeCurrency: {
    name: "WETH",
    symbol: "WETH",
    decimals: 18,
    imageUrl: "https://raw.seadn.io/files/WETH.svg",
    chain: "ethereum",
    contractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    chainIdentifier: "ethereum",
  },
  offerCurrency: {
    name: "WETH",
    symbol: "WETH",
    decimals: 18,
    imageUrl: "https://raw.seadn.io/files/WETH.svg",
    chain: "ethereum",
    contractAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    chainIdentifier: "ethereum",
  },
  listingCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    imageUrl: "https://raw.seadn.io/files/ETH.svg",
    chain: "ethereum",
    contractAddress: "0x0000000000000000000000000000000000000000",
    chainIdentifier: "ethereum",
  },
  logoDarkMode: {
    mono: MAINNET_LOGO_URL,
  },
  logoLightMode: {
    mono: MAINNET_LOGO_URL,
  },
  blockExplorer: {
    name: "Etherscan",
    url: "https://etherscan.io",
    addressUrlTemplate: "https://etherscan.io/address/:address",
    transactionUrlTemplate: "https://etherscan.io/tx/:hash",
    logoLightMode: {
      mono: "",
    },
    logoDarkMode: {
      mono: "",
    },
  },
}

export const DEFAULT_CHAINS: [Chain, ...Chain[]] = [mainnet]
